import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { ASSETS } from "@/lib/assets";
import { SEO } from "@/components/SEO";

const SERVICES = [
  {
    label: "Rottebekæmpelse",
    to: "/ydelser/rottebekaempelse",
    image: ASSETS.images.rats,
    blurb:
      "Certificeret rottebekæmpelse med lokalisering, sikring og dokumentation i både kloak og bygning.",
  },
  {
    label: "Kloakopgaver",
    to: "/ydelser/kloakopgaver",
    image: ASSETS.images.pipes,
    blurb:
      "Autoriseret kloakarbejde fra akutte afløbsproblemer til større renoveringer og anlægsopgaver.",
  },
  {
    label: "Serviceaftale",
    to: "/ydelser/serviceaftale",
    image: ASSETS.images.contract,
    blurb:
      "Forebyggende service af kloak og afløb, så problemer opdages i tide og driften holdes stabil.",
  },
  {
    label: "No-dig",
    to: "/ydelser/no-dig",
    image: ASSETS.images.noDig,
    blurb:
      "Strømpeforing og punktreparationer, hvor vi renoverer rørene uden unødvendig opgravning.",
  },
  {
    label: "Spul & Rens",
    to: "/ydelser/spul-rens",
    image: ASSETS.images.flush,
    blurb:
      "Højtryksspuling, rensning og TV-inspektion, når afløb stopper til eller skal dokumenteres.",
  },
];

export const Ydelser = () => {
  return (
    <>
      <SEO
        title="Ydelser – Kloak, rottebekæmpelse, no-dig & spuling"
        description="Se alle ydelser fra Farum Kloak: autoriseret kloakarbejde, rottebekæmpelse, serviceaftaler, no-dig strømpeforing, spul, rens og TV-inspektion i Nordsjælland."
      />
      <PageHero
        eyebrow="Ydelser"
        title={
          <>
            Hele kompetencebredden <em className="text-[color:var(--fk-gold)]">samlet ét sted.</em>
          </>
        }
        subtitle="Fra akutte skader til planlagte kloakprojekter. Vi har udstyret, erfaringen og holdet til at løse opgaven effektivt og dokumentere arbejdet ordentligt."
        image={ASSETS.images.industrialPipes}
      />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {SERVICES.map((s, i) => (
            <Link
              key={s.to}
              to={s.to}
              data-testid={`ydelser-card-${i}`}
              className="group relative overflow-hidden border border-white/10 hover:border-[color:var(--fk-gold)]/40 transition-all aspect-[4/3]"
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 group-hover:scale-105"
                style={{ backgroundImage: `url(${s.image})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-8 md:p-10">
                <div className="flex items-center justify-between mb-4">
                  <div className="eyebrow">0{i + 1}</div>
                  <ArrowUpRight className="w-5 h-5 text-white/60 group-hover:text-[color:var(--fk-gold)] group-hover:rotate-12 transition-all" />
                </div>
                <h3 className="font-display text-3xl md:text-4xl leading-tight">
                  {s.label}
                </h3>
                <p className="mt-3 text-sm md:text-base text-white/70 font-light max-w-md">
                  {s.blurb}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
};
